module.exports = __webpack_public_path__ + "static/bannerObject-3d79fd47096f0d163039f0ffb89e5893.png";